import { render, staticRenderFns } from "./AnalyticsFootnote.vue?vue&type=template&id=ec54b09a&scoped=true"
import script from "./AnalyticsFootnote.vue?vue&type=script&lang=js"
export * from "./AnalyticsFootnote.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsFootnote.vue?vue&type=style&index=0&id=ec54b09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54b09a",
  null
  
)

export default component.exports